import React from 'react';
import { User } from 'firebase/auth';
import { AppUser, PlatformConfig } from '../types';
interface TopBarProps {
  page: string;
  user: User | null;
  appUser: AppUser | null;
  onNavigate: (page: string) => void;
  onAuthClick: () => void;
  config: PlatformConfig | null;
  compact?: boolean;
}

export default function TopBar({ page, user, appUser, onNavigate, onAuthClick, config, compact }: TopBarProps) {
  return (
    <header className="topbar">
      <div className="topbar-inner">
        <div className="brand" onClick={() => onNavigate('home')} style={{ cursor: 'pointer' }}>
          {/* Decorative: the "SideQuests" wordmark is rendered as text beside it. */}
          <img src="/sidequests-logo.png" alt="" aria-hidden="true" style={{ width: 32, height: 32, aspectRatio: '1 / 1', objectFit: 'cover', borderRadius: '50%', clipPath: 'circle(50%)', display: 'block' }} />
          <div>
            <div className="brand-name">SideQuests</div>
          </div>
        </div>
        <div className="topbar-right">
          <button className="btn-icon" onClick={() => onNavigate('map')} aria-label="Map">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.086 2.207 3 6.997v12l7.086-4.79a4 4 0 0 1 3.828 0L21 18.997v-12l-7.086-4.79a4 4 0 0 0-3.828 0Z"/>
              <path d="M10.086 2.207v12"/>
            </svg>
          </button>
          <div className="auth-badge" onClick={user ? () => onNavigate('profile') : onAuthClick}>
            <span className={`auth-dot ${user ? 'online' : ''}`} />
            <span className="auth-label">
              {user ? (appUser?.displayName || user.email?.split('@')[0] || 'Quester') : 'Sign in'}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
